/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  addPortfolio,
  getDetailPortfolio,
  getListRoomStyle,
  getProfile,
  updatePortfolio,
} from '../../../services';
import Select from 'react-select';
import {
  formatMoney,
  getFileExtension,
  getFileNameAndExtension,
  urlToFile,
} from '../../../helper/lib';
import FileUpload from '../../../organism/FileUpload/FileUpload';
import AttachmentPreview from '../../../organism/AttachmentPreview';
import FadeLoader from 'react-spinners/FadeLoader';
import { changeDataProfile } from '../../../store';

import $ from 'jquery';
import { IsAlert } from '../../../atoms/IsAlert';
import { toast } from 'react-toastify';
import CaretLeftLightIcon from '../../../assets/img/custom/caret-left-light.svg';

const AddPortfolio = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { dataProfile } = useSelector((state) => state.global);
  const [title, setTitle] = useState('');
  const [budget, setBudget] = useState(
    dataProfile?.cp_price_per_m
      ? formatMoney(dataProfile.cp_price_per_m, '')
      : 0
  );
  const [styles, setStyles] = useState([]);
  const [description, setDescription] = useState('');
  const [styleSelected, setStyleSelected] = useState([]);
  const [showUploadInput, setShowUploadInput] = useState(true);
  const [samplePreview, setSamplePreview] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [idData, setIdData] = useState(null);
  const [tempPhotos, setTempPhotos] = useState([]);
  const [styleDesignTemp, setStyleDesignTemp] = useState('[]');
  const [loadAttachment, setLoadAttachment] = useState(false);

  const location = useLocation();
  const id = location.pathname.slice(27);

  const getDetailPortfolioData = async () => {
    try {
      const payload = {
        portfolioId: parseInt(id),
      };

      const response = await getDetailPortfolio(payload);

      if (response.message === 'Success') {
        const {
          nameTitle,
          budget,
          descriptionDesign,
          styleDesignId,
          id,
          photos,
        } = response.data;
        setTitle(nameTitle);
        setBudget(formatMoney(budget, ''));
        setDescription(descriptionDesign);
        setIdData(id);
        setTempPhotos(photos.map((el) => el.full_image_url));
        setStyleDesignTemp(styleDesignId);
      }
    } catch (error) {
      console.log('error:', error.response.data.message);
    }
  };

  const getUserData = async () => {
    try {
      const response = await getProfile();

      if (response.message === 'Success') {
        dispatch(changeDataProfile(response.data));
      }
    } catch (error) {
      console.log('error:', error.response.data.message);
    }
  };

  const getStyleLists = async () => {
    try {
      const response = await getListRoomStyle();

      if (response.message === 'Success') {
        setStyles(
          response?.data.map((val) => ({
            value: val?.id,
            label: val?.name,
          }))
        );

        setStyleSelected(
          JSON.parse(styleDesignTemp).map((style) => {
            let findStyle = styles.find(
              (item) => parseInt(item.value) === parseInt(style)
            );
            return findStyle;
          })
        );
      }
    } catch (error) {
      console.log('error:', error.response.data.message);
    }
  };

  const loadImage = async (photos) => {
    const previewImages = [];
    setLoadAttachment(true);

    for (let i = 0; i < photos.length; i++) {
      let file = photos[i];
      if (file !== '') {
        const converURLtoFile = await urlToFile(
          file,
          getFileNameAndExtension(file)?.name,
          `image/${getFileNameAndExtension(file)?.type}`
        );

        if (converURLtoFile) {
          previewImages.push({
            name: `${getFileNameAndExtension(file)?.name}.${
              getFileNameAndExtension(file)?.type
            }`,
            size: Math.round((converURLtoFile.size / 1000000) * 100) / 100,
            preview: file,
            file: converURLtoFile,
          });
        }
      }
    }

    setSamplePreview(previewImages);
    setLoadAttachment(false);
  };

  useEffect(() => {
    if (location.pathname.slice(20, 26) === 'update') {
      setIsEdit(true);
      getDetailPortfolioData();
    }
    getStyleLists();
    getUserData();
  }, []);

  useEffect(() => {
    // set style selected
    setStyleSelected(
      JSON.parse(styleDesignTemp).map((style) => {
        let findStyle = styles.find(
          (item) => parseInt(item.value) === parseInt(style)
        );
        return findStyle;
      })
    );
  }, [styleDesignTemp, styles]);

  const handleChange = (selectedOption) => {
    setStyleSelected(selectedOption);
  };

  const handleUploadFiles = async (files) => {
    if (samplePreview.length + files.length > 5) {
      IsAlert.fire({
        title: 'Error',
        text: 'Maximum Upload 5 Files',
        icon: 'error',
      });

      return;
    }
    files.forEach(async (file) => {
      const fileExtension = await getFileExtension(file.name);
      const fsize = Math.round((file.size / 1000000) * 100) / 100;
      if (!['jpeg', 'jpg', 'png'].includes(fileExtension.toLowerCase())) {
        // Alert
        IsAlert.fire({
          title: 'Error',
          text: 'Please upload file with the following extension only: jpeg, jpg, png',
          icon: 'error',
        });

        return;
      }

      if (fsize > 40.0) {
        IsAlert.fire({
          title: 'Error',
          text: 'Please upload image with a size of 40 MB or less per file',
          icon: 'error',
        });
        return;
      }

      const previewImage = URL.createObjectURL(file);
      //const base64 = await convertBase64(file);

      setSamplePreview((prev) => [
        ...prev,
        {
          name: file.name,
          size: fsize,
          preview: previewImage,
          file: file,
        },
      ]);

      return;
    });
  };

  const clearImageSelected = (index) => {
    const filtered = samplePreview.filter((_, i) => {
      return i !== index;
    });
    setSamplePreview(filtered);
  };

  useEffect(() => {
    // show hide box image upload
    if (samplePreview.length >= 5) {
      setShowUploadInput(false);
    } else {
      if (showUploadInput) {
        return;
      }
      setShowUploadInput(true);
    }
  }, [samplePreview]);

  const submitForm = async (event) => {
    event.preventDefault();
    try {
      const style = styleSelected.map((i) => i.value);

      const formData = new FormData();

      formData.append('title', title);
      formData.append('budget', parseInt(budget.replaceAll('.', '')));
      formData.append('style', JSON.stringify(style));
      formData.append('description', description);
      samplePreview.forEach((file) => {
        formData.append('photos', file.file);
      });

      if (isEdit) {
        formData.append('portfolioId', idData);
        formData.append('isPrimary', true);
      }

      const response = isEdit
        ? await updatePortfolio(formData)
        : await addPortfolio(formData);

      if (isEdit) {
        if (response?.message === 'Success') {
          toast.success('Success Update Portfolio');
          navigate(-1);
          return;
        }
      }

      if (response?.message === 'Success') {
        toast.success('Success Add Portfolio');
        navigate('/portfolio');
        return;
      }
    } catch (error) {
      IsAlert.fire({
        title: 'Failed',
        text: error.response?.data.message ?? 'Something when wrong.',
        icon: 'error',
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: 'Confirm',
      });
      console.error(error.response.data.message);
    }
  };

  useEffect(() => {
    if (tempPhotos) {
      loadImage(tempPhotos);
    }
  }, [tempPhotos]);

  return (
    <div className="container-fluid mb-4 px-0 tab-navigasi">
      <div className="mb-4">
        <a onClick={() => navigate(-1)} className="fs-6 fw-bold">
          <img
            src={CaretLeftLightIcon}
            className="icon-4 me-2"
            alt="img-caret-left-light"
          />
          {isEdit && 'Edit Portfolio'}
          {!isEdit && 'Add Portfolio'}
        </a>
      </div>
      <div className="w-100 pb-3 pb-lg-4 mb-3 mb-lg-4 border-bottom border-lg-0">
        <div className="w-100 swiper-nav swiper">
          <ul
            className="nav nav-pills ff2 nav-wrap swiper-wrapper"
            id="pills-tab"
            role="tablist"
          >
            <li className="nav-item swiper-slide" role="presentation">
              <button
                className="nav-link active"
                id="pills-information-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-information"
                type="button"
                role="tab"
                aria-controls="pills-information"
                aria-selected="true"
              >
                Information
              </button>
            </li>
            <li className="nav-item swiper-slide" role="presentation">
              {title && budget && styleSelected ? (
                <button
                  className="nav-link"
                  id="pills-photos-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-photos"
                  type="button"
                  role="tab"
                  aria-controls="pills-photos"
                  aria-selected="false"
                >
                  Photos
                </button>
              ) : (
                <button
                  disabled
                  className="nav-link"
                  id="pills-photos-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-photos"
                  type="button"
                  role="tab"
                  aria-controls="pills-photos"
                  aria-selected="false"
                >
                  Photos
                </button>
              )}
            </li>
          </ul>
          <div className="swiper-button-next"></div>
          <div className="swiper-button-prev"></div>
        </div>
      </div>

      <div>
        <div className="tab-content" id="pills-tabContent">
          {/* <!-- Information --> */}
          <div
            className="tab-pane fade show active"
            id="pills-information"
            role="tabpanel"
            aria-labelledby="pills-information-tab"
          >
            <div className="fs-5 fw-bold mt-2 mb-4">Portfolio Information</div>
            <div className="d-sm-flex mb-4">
              <div className="col-12 col-sm-6 ps-sm-2">
                <label className="form-label d-flex fw-semibold">
                  Title<div className="text-danger ps-1">*</div>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={title}
                  onChange={(event) => {
                    setTitle(event.target.value);
                  }}
                  required
                />
              </div>
              <div className="col-12 col-sm-6 ps-sm-2">
                <label className="form-label d-flex fw-semibold">
                  Style<div className="text-danger ps-1">*</div>
                </label>
                <Select
                  isMulti
                  options={styles}
                  value={styleSelected}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="d-sm-flex mb-4">
              {/* <div className="col-12 col-sm-6 ps-sm-2">
                <label className="form-label d-flex fw-semibold">
                  Budget<div className="text-danger ps-1">*</div>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={budget}
                  onChange={(event) => {
                    setBudget(event.target.value);
                  }}
                  onKeyUp={(event) =>
                    setBudget(
                      formatMoney(event.target.value.replaceAll('.', ''), '')
                    )
                  }
                />
              </div> */}
              <div className="col-12 col-sm-6 ps-sm-2">
                <label className="form-label d-flex fw-semibold">
                  Description
                </label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={description}
                  onChange={(event) => {
                    setDescription(event.target.value);
                  }}
                ></textarea>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <div className="col-12 col-sm-4 ps-sm-2 d-flex justify-content-end">
                <button
                  type="button"
                  disabled={!title || styleSelected.length === 0}
                  className="btn w-50 fw-semibold btn-fill px-5 mt-3 ask"
                  onClick={() => {
                    $('#pills-photos-tab').click();
                  }}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
          {/* <!-- Photos --> */}
          <div
            className="tab-pane fade"
            id="pills-photos"
            role="tabpanel"
            aria-labelledby="pills-photos-tab"
          >
            <div className="fs-5 fw-bold mt-2 mb-4">Photos</div>

            {loadAttachment ? null : (
              <>
                {showUploadInput ? (
                  <FileUpload
                    upload={handleUploadFiles}
                    samplePreviews={samplePreview}
                    maxFile={5}
                    maxSizePerFile={40}
                  />
                ) : null}
              </>
            )}

            <div className="container m-0 p-0 w-100 mt-3">
              <div className="row m-0 p-0">
                {samplePreview &&
                  samplePreview.length > 0 &&
                  samplePreview.map((image, index) => (
                    <div
                      key={index + 'attachment'}
                      className="col-12 col-sm-12 col-md-6 col-lg-4 m-0 p-0 pe-2 mb-2"
                    >
                      <AttachmentPreview
                        attachment={image}
                        handleClear={clearImageSelected.bind(this, index)}
                      />
                    </div>
                  ))}

                {loadAttachment ? (
                  <div className="d-flex align-items-center p-0 m-0">
                    <FadeLoader
                      height={15}
                      radius={2}
                      width={5}
                      speedMultiplier={1}
                      loading={loadAttachment}
                    />
                    <h6 className="ms-3">Loading Attachment</h6>
                  </div>
                ) : null}
              </div>
            </div>

            <div className="d-flex justify-content-between mt-2">
              <div className="col-12 col-sm-4 ps-sm-2">
                <button
                  type="button"
                  className="btn w-50 fw-semibold btn-fill px-5 mt-3 ask"
                  onClick={() => {
                    $('#pills-information-tab').click();
                  }}
                >
                  Previous
                </button>
              </div>

              <div className="col-12 col-sm-4 ps-sm-2 text-end">
                <button
                  type="button"
                  className="btn w-50 fw-semibold btn-fill px-5 mt-3 ask"
                  disabled={!(samplePreview.length > 0)}
                  onClick={submitForm}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPortfolio;
